<template>
  <div class="tz-container">
    <div class="tz-header">
      <b-container class="tz-center">
        <b-row>
          <b-col sm> </b-col>
          <b-col sm v-if="!!competition">
            <div class="haf_circle">
              <div>
                <b-img src="/static/image/tx80x80.png" />
                <div>
                  {{ userInfo.name }}|{{ userInfo.school }}|{{
                    userInfo.className
                  }}
                </div>
              </div>
            </div>
            <div>{{ userInfo.name }}的{{ competition.name }}</div>
            <div class="tz-tab">
              <div
                v-for="item in competition.stageList"
                :key="item.id"
                :class="stageId == item.id ? 'tz-tab-selected' : ''"
                @click="changeStage(item.id)"
              >
                <div>{{ item.name }}</div>
              </div>
            </div>
          </b-col>
          <b-col sm> </b-col>
        </b-row>
      </b-container>
      <b-container class="ranking-info" v-if="!!memberInfo">
        <b-row>
          <b-col>
            <div>
              <b-img src="/static/image/icon1_105x105.png" />
              <div>个人总收益率</div>
              <div class="tz-font tz-font-blue">
                {{ numberFixed(memberInfo.currentRatio * 100) }}%
              </div>
            </div>
          </b-col>
          <b-col>
            <div>
              <b-img src="/static/image/icon2_105x105.png" />
              <div>个人综合排名</div>
              <div class="tz-font tz-font-yellow">
                {{ memberInfo.personalRank }}/{{ competition.peopleCount }}
              </div>
            </div>
          </b-col>
          <b-col v-if="competition.type == 1">
            <div>
              <b-img src="/static/image/icon3_105x105.png" />
              <div>团队综合排名</div>
              <div class="tz-font tz-font-orange">
                {{ memberInfo.teamRank }}/{{ competition.teamCount }}
              </div>
            </div>
          </b-col>
          <b-col>
            <div>
              <b-img src="/static/image/icon4_105x105.png" />
              <div>累计盈亏</div>
              <div class="tz-font tz-font-purple">
                {{ numberFixed(memberInfo.overRatio) }}元
              </div>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>
    <div>
      <b-container class="tz-title">
        <b-row>
          <b-col sm> </b-col>
          <b-col sm>
            <div>
              <b-img src="/static/image/icon5_40x40.png" />
              <span class="tz-bold">{{ userInfo.name }}的总成绩</span>
            </div>
          </b-col>
          <b-col sm> </b-col>
        </b-row>
      </b-container>

      <b-container class="tz-draw-panel">
        <b-row>
          <b-col sm="6">
            <div class="tz-panel">
              <div>
                <div>
                  <b-img src="/static/image/icon8_40x40.png" />
                  个人收益率趋势
                </div>
                <div>创建日期{{ createTime }}</div>
              </div>
              <div id="personalRatio" style="width:100%; height:100%"></div>
            </div>
          </b-col>
          <b-col v-if="competition.type == 1" sm="6">
            <div class="tz-panel">
              <div>
                <div>
                  <b-img src="/static/image/icon7_40x40.png" />
                  团队收益率趋势
                </div>
                <div>创建日期{{ createTime }}</div>
              </div>
              <div id="teamRatio" style="width:100%; height:100%"></div>
            </div>
          </b-col>
        </b-row>

        <b-row>
          <b-col sm>
            <div class="tz-panel">
              <div>
                <div class="tz-bg-yellow">
                  <b-img src="/static/image/icon8_40x40.png" />
                  个人综合排名走势
                </div>
                <div>创建日期{{ createTime }}</div>
              </div>
              <div id="personalRanking" style="width:100%; height:100%"></div>
            </div>
          </b-col>
          <b-col v-if="competition.type == 1" sm>
            <div class="tz-panel">
              <div>
                <div class="tz-bg-yellow">
                  <b-img src="/static/image/icon7_40x40.png" />
                  团队综合排名走势
                </div>
                <div>创建日期{{ createTime }}</div>
              </div>
              <div id="teamRanking" style="width:100%; height:100%"></div>
            </div>
          </b-col>
        </b-row>
      </b-container>

      <b-container class="tz-title">
        <b-row>
          <b-col sm> </b-col>
          <b-col sm>
            <div>
              <b-img src="/static/image/icon6_40x40.png" />
              <span class="tz-bold">持仓期货</span>
            </div>
          </b-col>
          <b-col sm> </b-col>
        </b-row>
      </b-container>

      <b-container class="tz-position-container">
        <div class="tz-panel2">
          <div class="tz-table-header">
            <div>
              代码
            </div>
            <div>
              名称
            </div>
            <div>
              数量(总/今)
            </div>
            <div>
              可平
            </div>
            <div>
              最新价
            </div>
            <div>
              持仓均价
            </div>
            <div>
              持仓市值
            </div>
            <div>
              盈亏比
            </div>
            <div>
              浮动盈亏
            </div>
          </div>
        </div>
        <div class="table-content">
          <div
            v-for="item in positionList"
            :key="item.symbol"
            class="tz-table-row"
          >
            <div>{{ item.symbol }}</div>
            <div>{{ item.sec_name }}</div>
            <div>
              {{
                item.available +
                  "/" +
                  (!item.available_today ? "0" : item.available_today)
              }}
            </div>
            <div>{{ !item.available_now ? "0" : item.available_now }}</div>
            <div>{{ numberFixed(item.price) }}</div>
            <div>{{ numberFixed(item.last_price) }}</div>
            <div>{{ numberFixed(item.amount) }}</div>
            <div>{{ numberFixed(item.fpnl / item.amount) }}</div>
            <div
              :class="
                item.fpnl > 0 ? 'tz-table-row-raise' : 'tz-table-row-down'
              "
            >
              {{ numberFixed(item.fpnl) }}
            </div>
          </div>
        </div>
      </b-container>
    </div>
  </div>
</template>
<script>
import * as echarts from "echarts";
import * as competitionApi from "@/api/competition";
import { getInfo } from "@/utils/auth";
import * as memberApi from "@/api/member";
import * as rankingApi from "@/api/ranking";

export default {
  data() {
    return {
      personalCharts: null,
      teamCharts: null,
      personalRankingCharts: null,
      teamRankingCharts: null,
      compId: 0,
      stageId: 0,
      currentStage: null,
      positionList: [],
      userInfo: null,
      memberInfo: null,
      createTime: new Date().Format("yyyy-MM-dd")
    };
  },
  props: {
    competition: {
      type: Object,
      default: null
    }
  },
  created() {
    if (this.$route.query) {
      this.compId = this.$route.query.id;
    }
    this.userInfo = getInfo();
  },
  watch: {
    competition: function(nv) {
      this.stageId = this.competition.stageList[0].id;
      this.loadData();
    }
  },
  mounted() {
    if (this.competition) {
      this.stageId = this.competition.stageList[0].id;
      this.loadData();
    }
  },
  methods: {
    listPosition() {
      competitionApi
        .position({ compId: this.compId, stageId: this.stageId })
        .then(res => {
          this.positionList = [];
          if (res.code == 200) {
            this.positionList = res.data;
          }
        });
      rankingApi.listAll(this.compId, this.stageId).then(res => {
        if (res.code == 200) {
          this.draw("personalRatio", res.data.list);
          this.draw("teamRatio", res.data.list);
          this.drawRanking("personalRanking", res.data.list);
          this.drawRanking("teamRanking", res.data.list);
        }
      });
    },
    getMemberInfo() {
      memberApi.getMemberInfo(this.compId, this.stageId).then(res => {
        if (res.code == 200) {
          this.memberInfo = res.data;
        }
      });
    },
    loadData() {
      this.listPosition();
      this.getMemberInfo();
    },
    changeStage(id) {
      this.stageId = id;
      this.getCurrentStage(id);
      this.loadData();
    },

    numberFixed(num) {
      if (typeof num == "number") {
        return num.toFixed(2);
      } else {
        return 0;
      }
    },
    getCurrentStage(id) {
      let stage = this.competition.stageList.filter(st => {
        return st.id == id;
      });
      if (stage) {
        this.currentStage = stage;
      }
    },
    draw(id, rankList) {
      let title = "";
      if (id == "personalRatio") {
        title = "个人收益率";
      } else {
        title = "团队收益率";
      }
      let date = [];
      let data = [];
      let data2 = [];
      for (let i = 0; i < rankList.length; i++) {
        let tmp = rankList[i];
        var now = new Date(tmp.updateTime);
        date.push(
          [now.getFullYear(), now.getMonth() + 1, now.getDate()].join("/")
        );
        if (id == "personalRatio") {
          data.push(this.numberFixed(tmp.pnlRatio * 100));
        } else {
          data.push(this.numberFixed(tmp.teamRatio * 100));
        }

        data2.push(this.numberFixed(tmp.baseRatio * 100));
      }
      let option = {
        tooltip: {
          trigger: "axis",
          textStyle: {
            align: "left"
          },
          formatter: function(params) {
            var html = params[0].axisValue + "<br/>";
            for (var i = 0; i < params.length; i++) {
              html +=
                params[i].marker +
                params[i].seriesName +
                ":" +
                params[i].value +
                "%<br/>";
            }
            return html;
          }
        },
        legend: {
          data: ["基准收益率(HS300)", title]
        },
        title: {
          left: "center"
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: date
        },
        yAxis: {
          type: "value",
          axisLabel: {
            show: true,
            interval: "auto",
            formatter: "{value} %"
          },
          boundaryGap: [0, "10%"]
        },
        dataZoom: [
          {
            type: "inside",
            start: 0,
            end: 100
          },
          {
            start: 0,
            end: 10
          }
        ],
        series: [
          {
            name: title,
            type: "line",
            itemStyle: {
              color: "#f1944b"
            },
            stack: "Total",
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "#6c3b3f"
                },
                {
                  offset: 1,
                  color: "#62473e"
                }
              ])
            },
            data: data
          },
          {
            name: "基准收益率(HS300)",
            type: "line",
            itemStyle: {
              color: "#6991c7"
            },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "#467fb4"
                },
                {
                  offset: 1,
                  color: "#5b94d9"
                }
              ])
            },
            data: data2
          }
        ]
      };
      console.log(id, id == "personalRatio");
      if (id == "personalRatio") {
        try {
          if (!this.personalCharts) {
            this.personalCharts = echarts.init(document.getElementById(id));
          }
          this.personalCharts.setOption(option, true);
        } catch (e) {}
      } else {
        try {
          if (!this.teamCharts) {
            this.teamCharts = echarts.init(document.getElementById(id));
          }
          this.teamCharts.setOption(option);
        } catch (e) {}
      }
    },
    drawRanking(id, rankList) {
      let xData = [];
      let yData = [];
      for (var i = 0; i < rankList.length; i++) {
        let tmp = rankList[i];
        xData.push(tmp.updateTime);
        if (id == "personalRanking") {
          yData.push(tmp.personalRank);
        } else {
          yData.push(tmp.teamRank);
        }
      }

      let option = {
        tooltip: {
          trigger: "axis",
          textStyle: {
            align: "left"
          }
        },
        xAxis: {
          type: "category",
          data: xData,
          axisLine: {
            onZero: false
          }
        },
        yAxis: {
          type: "value",
          boundaryGap: [0, "10%"],
          inverse: true
        },
        series: [
          {
            data: yData,
            type: "line",
            color: "#faa7c1"
          }
        ]
      };
      console.log(id, id == "personalRanking");
      if (id == "personalRanking") {
        try {
          if (!this.personalRankingCharts) {
            this.personalRankingCharts = echarts.init(
              document.getElementById(id)
            );
          }
          this.personalRankingCharts.setOption(option);
        } catch (e) {}
      } else {
        try {
          if (!this.teamRankingCharts) {
            this.teamRankingCharts = echarts.init(document.getElementById(id));
          }
          this.teamRankingCharts.setOption(option);
        } catch (e) {}
      }
    }
  }
};
</script>
<style scoped>
.tz-container {
  padding-bottom: 3rem;
  text-align: center;
}

@media screen and (min-width: 375px) and (max-width: 1440px) {
  .tz-draw-panel {
    max-width: unset;
  }
  .tz-position-container {
    max-width: unset;
  }
}
.tz-table-header {
  display: flex;
  background: #0162e4;
  color: white;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}
.tz-table-header > div {
  width: 100%;
  padding: 1rem;
}
.tz-table-row {
  display: flex;
  background-color: white;
  color: black;
}
.tz-table-row > div {
  width: 100%;
  padding: 1rem;
  border-bottom: 1px solid #d9d9d9;
  border-left: 1px solid #d9d9d9;
  font-size: 80%;
}
.tz-table-row > div:nth-last-child(0) {
  border-left: none !important;
}
.tz-table-row-raise {
  color: #ff0000;
}
.tz-table-row-down {
  color: #008934;
}
.tz-title {
  margin-top: 1rem;
  margin-bottom: 1rem;
}
.tz-panel {
  min-height: 320px;
  margin-top: 1rem;
  margin-bottom: 1rem;
  background-color: white;
  border-radius: 10px;
  box-shadow: -1px -1px 20px 1px #c4c4c4;
}
.tz-panel2 {
  margin-top: 1rem;
  background-color: white;
  border-radius: 10px;
  box-shadow: -1px -1px 20px 1px #c4c4c4;
}
.tz-bg-yellow {
  background-color: #f47419 !important;
}
.tz-panel > div:nth-child(1) {
  display: flex;
  line-height: 3;
}
.tz-panel > div:nth-child(2) {
  min-height: 320px;
}
.tz-panel > div:nth-child(1) > div:nth-child(1) {
  width: 65%;
  background-color: #0263d3;
  color: white;
  text-align: left;
  border-top-left-radius: 10px;
}
.tz-panel > div:nth-child(1) > div:nth-child(2) {
  width: 35%;
  background: #2b2b2b;
  color: white;
  border-top-right-radius: 10px;
}

.tz-bold {
  font-weight: bolder;
  font-size: 120%;
}
.ranking-info {
  margin-top: 1rem;
  margin-bottom: 1rem;
  padding-bottom: 1rem;
  font-weight: bold;
}
.ranking-info img {
  margin-bottom: 0.5rem;
}
.tz-font {
  font-size: 150%;
}
.tz-font-blue {
  color: #0162e4;
}
.tz-font-yellow {
  color: #e46601;
}
.tz-font-orange {
  color: #ff2626;
}
.tz-font-purple {
  color: #8e03fe;
}
.tz-tab {
  display: flex;
  width: 120%;
  margin-left: -10%;
  margin-bottom: 1rem;
  margin-top: 1rem;
  border-radius: 5px;
}
.tz-tab > div {
  width: 100%;
  background: white;
  color: black;
  padding: 0.5rem;
  border-right: 1px solid #e5e5e5;
}
.tz-tab-selected {
  background: #016ee6 !important;
  color: white !important;
}
.tz-tab-selected::after {
  content: "";
  background-image: url(/static/image/down_trangle.png);
  background-size: cover;
  width: 2rem;
  height: 1rem;
  position: absolute;
  margin-left: -0.8rem;
  margin-top: 0.4rem;
}
.tz-tab > div:hover::after {
  content: "";
  background-image: url(/static/image/down_trangle.png);
  background-size: cover;
  width: 2rem;
  height: 1rem;
  position: absolute;
  margin-left: -0.8rem;
  margin-top: 0.4rem;
}
.tz-tab > div:nth-child(1) {
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
}
.tz-tab > div:nth-last-child(1) {
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
}

.tz-tab > div:hover {
  background: #016ee6;
  color: white;
}
.haf_circle {
  background-image: url(/static/image/tx_bg390x165.png);
  width: 24.125rem;
  height: 10rem;
  border-top-right-radius: 50rem;
  border-top-left-radius: 50rem;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  color: white;
}
.haf_circle img {
  margin-bottom: 1rem;
}
.tz-center {
  display: flex;
  justify-content: center;
}
.tz-header {
  padding-top: 1rem;
  background-color: #e7f0f5;
}
</style>



// WEBPACK FOOTER //
// src/views/competition/second.vue